import { ChartBoxOutlineIcon } from './ChartBoxOutlineIcon';

/**
 * author: Google
 * id 4115E465-01E5-4F3F-929A-81C239289B21
 * name chart-box-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-box-outline.svg
 * tags
 * - Math 
 */
export const PollBoxOutlineIcon = ChartBoxOutlineIcon;
export default PollBoxOutlineIcon